"use strict";

import React, {Component} from 'react';

class ContentWrapper extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="content-wrapper m0">
                {this.props.children}
            </div>
        )
    }
}

export default ContentWrapper;